import { render, staticRenderFns } from "./BreadCrumbCustom.vue?vue&type=template&id=28a4b2aa&scoped=true&"
import script from "./BreadCrumbCustom.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbCustom.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbCustom.vue?vue&type=style&index=0&id=28a4b2aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a4b2aa",
  null
  
)

export default component.exports